exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.select-container[data-v-536f4c97]{\n  display: flex;\n  gap: 15px;\n}\n.form-item__wrap[data-v-536f4c97] {\n  margin: 0px;\n  padding: 0px;\n  display: flex;\n  align-items: baseline;\n}\n.c-select_wrap__text[data-v-536f4c97]{\n  padding-left: 15px;\n}\n", ""]);

// exports
